export default __webpack_public_path__ + "static/media/oxxopay_brand.ba1c5f55.png";